import * as THREE from 'three';
import { LOOP } from '../config';

/** 매 프레임 dt(초)를 받아 상태를 갱신하는 함수. */
export type Updatable = (dt: number) => void;

/**
 * 렌더 루프 오케스트레이터. 각 시스템이 update 콜백을 등록(add)하고,
 * start()가 renderer.xr를 통한 setAnimationLoop로 모두를 매 프레임 호출한 뒤 렌더한다.
 * 새 기능(로코모션, 벽 콘텐츠 교체 등)은 루프를 건드리지 않고 add()만 하면 된다.
 */
export class Loop {
  private readonly timer = new THREE.Timer();
  private readonly updatables: Updatable[] = [];

  constructor(
    private readonly renderer: THREE.WebGLRenderer,
    private readonly scene: THREE.Scene,
    private readonly camera: THREE.Camera,
  ) {
    // Page Visibility API: 탭이 숨겨지는 동안 delta=0 → 복귀 시 큰 점프(멀미 유발) 방지.
    this.timer.connect(document);
  }

  add(update: Updatable): void {
    this.updatables.push(update);
  }

  start(): void {
    this.renderer.setAnimationLoop(() => {
      this.timer.update();
      // 그 외 비정상적으로 긴 프레임(GC 등)도 maxDelta로 한 번 더 잘라준다.
      const dt = Math.min(this.timer.getDelta(), LOOP.maxDelta);
      for (const update of this.updatables) update(dt);
      this.renderer.render(this.scene, this.camera);
    });
  }

  stop(): void {
    this.renderer.setAnimationLoop(null);
  }
}
